import { get, put, post, upload } from 'api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL + `/document-partners`;

export function getPartnerAddresses(documentId, siteId, partnerId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/partner-addresses`);
}

export function updateOfferClientAddresses(documentId, siteId, partnerId, partnerAddresses) {
  return put(`${url}/${documentId}/${siteId}/${partnerId}/partner-addresses`, {
    documentId,
    siteId,
    partnerId,
    addresses: partnerAddresses
  });
}

export function getPartnerBankAccounts(partnerId, documentId, siteId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/bank-accounts`);
}

export function saveBankAccounts(documentId, siteId, partnerId, bankAccounts) {
  return post(`${url}/${documentId}/${siteId}/${partnerId}/bank-accounts`, {
    bankAccounts: bankAccounts
  });
}

export function getShareholders(partnerId, documentId, siteId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/2/shareholders`);
}

export function saveShareholders(documentId, siteId, partnerId, shareholders) {
  const data = {
    documentId: documentId,
    siteId: siteId,
    partnerId: partnerId,
    shareholders: shareholders
  };
  return post(`${url}/${documentId}/${siteId}/${partnerId}/shareholders`, data);
}

export function getProperties(partnerId, documentId, siteId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/properties`);
}

export function savePartnerProperties(documentId, siteId, partnerId, properties) {
  const data = {
    documentId: documentId,
    siteId: siteId,
    partnerId: partnerId,
    properties: properties
  };
  return put(`${url}/${documentId}/${siteId}/${partnerId}/properties`, data);
}

export function getPartnerContactModes(documentId, siteId, partnerId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/contact-modes`);
}

export function saveContactModes(documentId, siteId, partnerId, contactModes) {
  const data = {
    documentId: documentId,
    siteId: siteId,
    partnerId: partnerId,
    documentPartnerContactModes: contactModes
  };
  return post(`${url}/${documentId}/${siteId}/${partnerId}/contact-modes`, data);
}

export function getDocumentPartnerRelations(documentId, siteId) {
  return get(`${url}/${documentId}/${siteId}/partner-relations`);
}

export function saveDocumentPartnerRelation(partnerRelationId, documentId, siteId, item) {
  post(`${url}/${documentId}/${siteId}/partner-relations`, {
    item: item,
    partnerRelationId: partnerRelationId,
    documentId: documentId,
    siteId: siteId
  });
}

export function loadDocumentAssociatedPartners(documentId, siteId) {
  return get(`${url}/${documentId}/${siteId}/associated-partners`);
}

export function getContactPersons(documentId, siteId, partnerId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/contact-persons`);
}

export function saveContactPersons(documentId, siteId, partnerId, contactPersons) {
  const data = {
    documentId: documentId,
    siteId: siteId,
    partnerId: partnerId,
    documentPartnerContactPersons: contactPersons
  };
  return post(`${url}/${documentId}/${siteId}/${partnerId}/contact-persons`, data);
}

export function getActivityFields(documentId, siteId, partnerId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/activity-fields`);
}

export function saveActivityFields(documentId, siteId, partnerId, activityFields) {
  return post(`${url}/${documentId}/${siteId}/${partnerId}/activity-fields`, {
    activityFields: activityFields
  });
}

export function loadDocumentPartner(documentId, siteId, partnerId, documentTypeId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/${documentTypeId}`);
}

export function getPartnerConsent(documentId, siteId, partnerId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/consents`);
}

export function printOfferClientConsents(data) {
  return post(`${url}/${data.documentId}/${data.siteId}/consent/print`, data);
}

export function uploadOfferConsentDocument(documentId, siteId, formData, progressCallback) {
  return upload(`${url}/${documentId}/${siteId}/uploadConsentDocument`, formData, progressCallback);
}

export function updateOfferClientConsent(consent) {
  return put(`${url}/${consent.documentId}/${consent.siteId}/clientconsent`, consent);
}

export function updateOfferClientConsents(consents) {
  return put(`${url}/${consents.documentId}/${consents.siteId}/clientconsents`, consents);
}

export function getDocumentPartnerVerifications(documentId, siteId, partnerId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/verifications`);
}

export function getDocumentPartnerVerificationsSummary(documentId, siteId, partnerId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/verifications-summary`);
}

export function getDocumentPartnerContactPersonsSummary(documentId, siteId, partnerId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/contact-persons-summary`);
}

export function getShareholdersSummary(partnerId, documentId, siteId) {
  return get(`${url}/${documentId}/${siteId}/${partnerId}/shareholders-summary`);
}
